import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c31560c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "container_header" }
const _hoisted_3 = { class: "container_header_nav" }
const _hoisted_4 = { class: "container_center" }
const _hoisted_5 = { class: "container_textLeft" }
const _hoisted_6 = { class: "container_content" }
const _hoisted_7 = { class: "container_warn" }
const _hoisted_8 = { class: "container_progress" }
const _hoisted_9 = {
  key: 2,
  class: "container_footer"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "item_box" }
const _hoisted_12 = { class: "footer_to_left" }
const _hoisted_13 = { class: "dot_block" }
const _hoisted_14 = { class: "footer_img" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "footer_mantle" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "footer_to_right" }
const _hoisted_19 = { class: "right_span" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 6px"} }, "辨", -1))
const _hoisted_21 = { class: "right_bottom" }
const _hoisted_22 = { class: "right_title" }
const _hoisted_23 = { class: "right_title_text" }
const _hoisted_24 = {
  key: 3,
  class: "mod_pagin"
}
const _hoisted_25 = { class: "edit_message" }
const _hoisted_26 = { class: "edit_message_box" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit_head" }, "封面图：", -1))
const _hoisted_28 = { class: "edit_load" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit_tip" }, "上传说明：只支持jpg格式，16:9比例,大小不能超过3M。", -1))
const _hoisted_30 = { class: "edit_message_box" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit_heads" }, "标题：", -1))
const _hoisted_32 = { class: "edit_load" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_prompt" }, "标题说明：标题文本不能超过十个字，超过自动省略隐藏。", -1))
const _hoisted_34 = { class: "edit_use" }
const _hoisted_35 = { class: "down_message" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "down_message_head" }, "视频下载地址", -1))
const _hoisted_37 = { class: "down_message_content" }
const _hoisted_38 = {
  class: "content_area",
  id: "copy"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "down_message_heads" }, "视频下载工具", -1))
const _hoisted_40 = { class: "down_message_edition" }
const _hoisted_41 = { class: "edition_btn" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://images.innocomn.com/M3u8Downloader.rar" }, "Windows版", -1))
const _hoisted_43 = { class: "edition_btn" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://images.innocomn.com/Downie.dmg" }, "Mac版", -1))
const _hoisted_45 = {
  key: 0,
  style: {"display":"flex","justify-content":"space-around","position":"relative"}
}

import CDelModal from '@/components/CDelModal.vue';
import CUpload from '@/components/CUpload.vue';
import { Input, message, Upload, Button, Alert, Pagination, Modal, DatePicker, Spin, Progress } from 'ant-design-vue';
import { UploadOutlined, LoadingOutlined, SearchOutlined } from '@ant-design/icons-vue';
import ClipboardJS from 'clipboard';
import { computed, h, onMounted, onUnmounted, reactive, ref, watch } from 'vue';
import moment from 'moment';
import http from '@/api/media';
import { getToken, getHelperStatus } from '@/plugins/cookie';
import 'video.js/dist/video-js.css';
import { emptyDataSec } from '@/assets';
import { useDebounce } from '@/hooks/useDebounce';
import CLoading from '@/components/CLoading.vue';
import router from '@/router';
import { MessageType } from 'ant-design-vue/lib/message';
import { useHomeStore } from '@/pinia/home';
import TcVod from 'vod-js-sdk-v6';
// import { loadJs } from '@/utils/common';
import { useStore } from 'vuex';

interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: string;
  url?: string;
  type?: string;
  size: number;
  preview?: string;
  originFileObj: never;
}
interface lives {
  id: number;
  key: number;
  cover_url: string;
  title: string;
  created_at: string;
  resolution: string;
  size: any;
  choice: boolean;
  video_id: string;
  definition: string;
  video_url: string;
  source: number;
  ProjectId: string;
  code: number;
  duration: string;
  format?: string;
  dotting_status: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Media',
  setup(__props) {

const helper = getHelperStatus(); //直播助手标识
const { RangePicker } = DatePicker;
const homeStore = useHomeStore();
const videoDoting = computed(() => homeStore.funcData?.videoDoting); //  视频打点显示
const videoJianji = computed(() => homeStore.funcData?.videoJianji); //  视频打点显示
const showUseGuide = computed(() => homeStore.funcData.CloudGuide);
// const { proxy }: any = getCurrentInstance();
const aInputSearch = Input.Search;
const aUpload = Upload;
const aButton = Button;
const aAlert = Alert;
const aPagination = Pagination;
const aModal = Modal;
const aRangePicker = RangePicker;
const aSpin = Spin;
const aProgress = Progress;
LoadingOutlined;
const indicators = h(LoadingOutlined, {
  style: {
    fontSize: '14px',
    margin: '0 6px 0 0',
  },
  spin: true,
});

const ranges: any = {
  今天: [moment().startOf('day'), moment().endOf('day')],
  最近一周: [moment().startOf('day').subtract(1, 'weeks'), moment()],
  最近一月: [moment().startOf('day').subtract(1, 'months'), moment()],
  最近三月: [moment().startOf('day').subtract(3, 'months'), moment()],
};

const showLoading = ref<boolean>(false);
const checkNum = ref(0);
// 点击
let getLive = (id: number) => {
  if (checked.value || selected.value) {
    keys.value[id] = !keys.value[id];
  }
  changeCheckNum();
};
const changeCheckNum = () => {
  let arr: string[] = [];
  Object.keys(keys.value).forEach((k, j) => {
    keys.value[k] == true ? arr.push(Object.keys(keys.value)[j]) : '';
  });
  checkNum.value = arr.length;
};

//初始化3d
const vOptions = {
  language: 'zh-CN',
  notSupportedMessage: '此视频暂时无法播放,请稍后再试',
  controls: true,
  techOrder: ['html5', 'flvjs'], //html5模式和flvjs模式
  fluid: true, //流式布局,适应父元素大小
  flvjs: {
    mediaDataSource: {
      isLive: true, //是否是直播
      cors: true, //是否跨域
      withCredentials: false, //是否跨站检测
    },
  },
  preload: true, //预加载
  autoplay: true, //是否自动播放
  loop: true,
};
const videoRef = ref();
// onMounted(async () => {
//   await loadJs('https://videojs-vr.netlify.app/dist/videojs-vr.css');
//   await loadJs('https://videojs-vr.netlify.app/dist/videojs-vr.js');
// });
// // 初始化3d视频
const initVrPlayer = (data: any) => {
  videoPlayer.value = new window.videojs(videoRef.value, {
    // poster: poster,//海报
    playbackRates: [0.5, 0.75, 1, 1.5, 2], //播放速度
    language: 'zh-CN',
    notSupportedMessage: '此视频暂时无法播放,请稍后再试',
    controls: true,
    techOrder: ['html5'], //html5模式
    fluid: true, //流式布局,适应父元素大小
    aspectRatio: '16:9', //流式布局时，自适应大小的比例
    preload: true, //预加载
    autoplay: true, //是否自动播放
    loop: true,
  });
  try {
    videoPlayer.value.src({
      src: data.video_url,
    });
    videoPlayer.value.mediainfo = videoPlayer.value.mediainfo || {};
    videoPlayer.value.mediainfo.projection = '360';
    videoPlayer.value.vr({ projection: 'AUTO', debug: true, forceCardboard: false });
  } catch {
    // console.log();
  }
};

//视频显示窗
const modal2Visible = ref<boolean>(false);
//实例化播放器
const playStatus = ref<boolean>(false);
// const mediaPlay = ref();
const videoPlayer = ref();
const Mplayer = (play_data: any) => {
  videoPlayer.value = new window.videojs(videoRef.value, {
    // poster: poster,//海报
    playbackRates: [0.5, 0.75, 1, 1.5, 2], //播放速度
    language: 'zh-CN',
    notSupportedMessage: '此视频暂时无法播放,请稍后再试',
    controls: true,
    techOrder: ['html5'], //html5模式
    fluid: true, //流式布局,适应父元素大小
    aspectRatio: '16:9', //流式布局时，自适应大小的比例
    preload: true, //预加载
    autoplay: true, //是否自动播放
    loop: true,
  });
  videoPlayer.value.src({
    src: play_data.video_url,
  });
};
//点击蒙层销毁播放器
const modal2cancel = () => {
  playStatus.value = false;
  videoPlayer.value.dispose();
  modal2Visible.value = false;
};
//点击图片获取视频地址
let play_data = {
  video_url: '',
};
const videoPlay = (item: any) => {
  // console.log(item,666);
  playStatus.value = true;
  play_data.video_url = item.video_url;
  modal2Visible.value = true;
  setTimeout(() => {
    // if (item.is_vr_video == 0) {
    Mplayer(play_data); // 2d
    // } else {
    // initVrPlayer(play_data); //3d
    // }
  });
};
// 删除
const deleteLive = () => {
  deletes.value = true;
};
const openDelModal = () => {
  deletes.value = false;
};
// 确定删除
const ConfirmDelete = () => {
  let arr: string[] = [];
  Object.keys(keys.value).forEach((k, j) => {
    keys.value[k] == true ? arr.push(Object.keys(keys.value)[j]) : '';
  });
  deletes.value = false;
  let del = {
    video_ids: arr.join(','),
  };
  http
    .getDelDemandVideo({ params: del })
    .then((res) => {
      const resData = res.data;
      message.success(resData.message);
      demandVideoList();
      // 清空id
      let del: any = [];
      live.value.map((res) => {
        del.push(res.id);
      });
    })
    .catch((res) => {
      message.error(res.data.error);
    });
  checked.value = false;
  selected.value = false;
};
// 弹框
const confirm = ref(false);
const downs = ref(false);
const deletes = ref(false);
// 编辑
const edits = (item: any) => {
  obj.value.realm = item.title;
  obj.value.cover_url = item.cover_url;
  obj.value.upd_id = item.id;
  usedGuide.value = item.preprocess_type ? true : false;
  usedGuideDis.value = item.preprocess_type ? true : false;
  usedGuideId.value = item.video_id;
  confirm.value = true;
};
// 下载

const showModal = (item: any) => {
  // 左赋值
  obj.value.domain = item.video_url;
  downs.value = true;
};
// 复制
const Copylist = (btns: string) => {
  let ClipboardJSObj = new ClipboardJS(btns);
  ClipboardJSObj.on('success', function (e) {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', function () {
    message.destroy();
    message.info('复制失败');
  });
};

//保存
let token = getToken();
const keep = () => {
  confirm.value = false;
  !usedGuideDis.value ? submit_preprocess_jobs() : '';
  let upddemand = {
    id: obj.value.upd_id,
    cover_url: obj.value.cover_url,
    title: obj.value.realm,
  };
  http
    .getupdDemandVideo(upddemand)
    .then(() => {
      demandVideoList();
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
let obj = ref({
  realm: '',
  fileList: '',
  cover_url: '',
  upd_id: '',
  search: '',
  title: '',
  domain: '',
});
// s编辑内容
const loading = ref<boolean>(false);
// e编辑内容
const handlePreview = (info: FileInfo) => {
  if (info.file.status === 'uploading') {
    loading.value = true;
    return;
  } else loading.value = false;
  // 赋值自己传的值，使用JSON.parse方法拿到proxy里的值
  obj.value.cover_url = JSON.parse(JSON.stringify(info.file.response)).data.url;
  if (info.file.status === 'error') {
    loading.value = false;
    message.error('upload error');
  }
};
const imageDel = () => {
  obj.value.cover_url = '';
};
// 选择，全选
const checked = ref(false); //单选
const selected = ref(false); //全选
const GetChecktclassName = ref('');
const GetSelectClassName = ref('');
const SelectAll = () => {
  GetChecktclassName.value = 'item_select item_select_hover';
  if (checked.value === false) {
    Object.keys(keys.value).forEach((k) => {
      keys.value[k] = false;
    });
  }
  changeCheckNum();
};
const CheckAll = () => {
  GetSelectClassName.value = 'item_select_actived';
  if (selected.value === true) {
    Object.keys(keys.value).forEach((k) => {
      keys.value[k] = true;
    });
  } else {
    Object.keys(keys.value).forEach((k) => {
      keys.value[k] = false;
    });
  }
  changeCheckNum();
};
const keys = ref({});
// 单选高亮删除
const isSelected = computed(() => {
  return !Object.keys(keys.value).some((e) => keys.value[e] === true);
});
const live = ref<lives[]>([]);
// 分页
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 12, // 每页条数
  totalSize: 100, // 总数
  options: ['12', '24', '36', '48', '60'], // 选项
});
// 日历
const queryForm = ref([]);
let interval: any;
// 获取媒体库视频列表
const demandVideoList = useDebounce(() => {
  const demand = {
    state_time: queryForm.value[0] ? moment(queryForm.value[0]).format('YYYY-MM-DD HH:mm') : '',
    end_time: queryForm.value[1] ? moment(queryForm.value[1]).format('YYYY-MM-DD HH:mm') : '',
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
    keywords: obj.value.search,
    type: 0,
  };
  showLoading.value = true;
  http
    .getDemandVideoList({ params: demand })
    .then((res) => {
      checked.value = false;
      selected.value = false;
      showLoading.value = false;
      pageConfig.current = res.data.data.current_page;
      pageConfig.totalSize = res.data.data.total;
      live.value = [];
      keys.value = {};
      live.value = [...res.data.data.data];
      statusList.value = [];
      live.value.forEach((i) => {
        keys.value[i.id] = false;
        i.code == 206 ? statusList.value.push(i.id) : '';
      });
      clearInterval(interval);
      interval = setInterval(() => {
        if (statusList.value.length > 0) {
          getVideoStatus();
        } else {
          return;
        }
      }, 10000);
    })
    .catch(() => {
      showLoading.value = false;
    });
});
demandVideoList();

// 轮询视频转码
let statusList: any = ref([]);
const getVideoStatus = () => {
  const list = {
    ids: statusList.value.join(','),
  };
  http.getVideoStatus({ params: list }).then((res) => {
    let data = res.data.data;
    statusList.value = [];
    data.map((res: any) => {
      if (res.code == 206) {
        statusList.value.push(res.id);
      }
    });
    data.length > statusList.value.length || statusList.value.length == 0 ? demandVideoList() : '';
  });
};
// 创建云剪辑工程
const buildTimeLine = (value: lives) => {
  const title = value.title;
  const video_id = value.video_id;
  const definition = value.definition;
  const video_url = value.video_url;
  const source = value.source;
  let project_id;
  http.getBuildTimeLine({ title: title }).then((res) => {
    project_id = res.data.data.Project.ProjectId;
    // if (source == 0) {
      router.push({
        name: 'VideoClip',
        query: {
          project_id: project_id,
          video_id: video_id,
          video_url: video_url,
          title: title,
          source: value.source,
        },
      });
    // }
  });
};
// 视频打点
const clickEditorDot = (value: lives) => {
  router.push({
    name: 'VideoEditor',
    query: {
      video_id: value.video_id,
      video_url: value.video_url,
      cover_url: value.cover_url,
      duration: value.duration,
      title: value.title,
      format: value.format,
      size: value.size,
    },
  });
};

// 合并
const jumpMerge = () => {
  let arr: string[] = [];
  Object.keys(keys.value).forEach((k, j) => {
    keys.value[k] == true ? arr.unshift(Object.keys(keys.value)[j]) : '';
  });
  router.push({
    name: 'VideoMerge',
    query: {
      ids: arr.join(','),
    },
  });
};

const videoList = ref();
let videoData = ref();
const transformFile = (file: any) => {
  return uploading.value ? false : file.size;
};
const uploading = ref(false);
const percent = ref(0);
const store = useStore();
const video_storage = ref();
const customData = computed(() => store.state.home.customData);
video_storage.value = customData.value.video_storage;

const uploadVideo = (info: FileInfo) => {
  videoList.value = info.file;
  if (videoList.value.response && videoList.value.response.code == 200) {
    videoData.value = videoList.value.response.data;
    if (video_storage.value == 1) {
      //阿里云上传
      const Uploader = aliUpload(videoList.value.originFileObj?.size);
      Uploader.addFile(videoList.value.originFileObj, null, null, null);
      Uploader.startUpload();
    } else if(video_storage.value == 2) {
      // 腾讯上传
      tcVodUpload();
    }
     uploading.value = true;
    delete videoList.value.originFileObj.uid;

  } else {
    videoList.value.response ? message.error(videoList.value.response.error) : '';
  }
};

// 初始化上传
const loadingMsg = ref<MessageType>();
const existence = ref(false);
const existenceText = ref('');
let aliyunInterval: any;
const aliUpload = function (fileSize: number) {
  // let basePartSize = 1;
  // if (fileSize > 8 * 1024 * 1024 * 1024) {
  //   basePartSize = 8;
  // }
  const uploader = new window.AliyunUpload.Vod({
    userId: '260962291690669531',
    region: 'cn-shanghai',
    // partSize: basePartSize * 1024 * 1024, // 设置part大小
    // 添加文件成功
    addFileSuccess: function (uploadInfo: any) {
      console.log('addFileSuccess: ' + uploadInfo.file.name);
    },
    onUploadstarted: function (uploadInfo: any) {
      if (!uploadInfo.videoId) {
        console.log('正常上传');
        loadingMsg.value = message.loading('上传准备中，请耐心等候...', 0);
        //正常上传
        let data = {
          title: videoList.value.name,
          type: 1,
          size: videoList.value.size,
        };
        http
          .createUploadVideo(data)
          .then((res) => {
            console.log('正常上传then');
            let uploadAuth = res.data.data.UploadAuth;
            let uploadAddress = res.data.data.UploadAddress;
            let videoId = res.data.data.VideoId;
            uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId);
          })
          .catch((res) => {
            existence.value = true;
            existenceText.value = res.data.error;
            uploading.value = false;
            loadingMsg.value && setTimeout(loadingMsg.value, 0);
          });
      } else {
        console.log('断点续传');
        loadingMsg.value = message.loading('正在恢复上传，请耐心等候...', 0);
        // 断点续传
        let data = {
          video_id: uploadInfo.videoId,
        };
        http
          .refreshUploadVideo({ params: data })
          .then((res) => {
            let uploadAuth = res.data.data.UploadAuth;
            let uploadAddress = res.data.data.UploadAddress;
            let videoId = res.data.data.VideoId;
            uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId);
          })
          .catch(() => {
            uploading.value = false;
          });
      }
      clearInterval(aliyunInterval);
      aliyunInterval = setInterval(() => {
        console.clear();
      }, 10000);
    },
    // 文件上传成功
    onUploadSucceed: function () {
      setTimeout(() => {
        demandVideoList();
      }, 2000);
      uploading.value = false;
      clearInterval(aliyunInterval);
    },
    //文件上传失败
    onUploadFailed: function () {
      existence.value = true;
      existenceText.value = '文件上传失败';
      uploading.value = false;
      clearInterval(aliyunInterval);
      loadingMsg.value && setTimeout(loadingMsg.value, 0);
    },
    //文件上传进度，单位：字节
    onUploadProgress: function (uploadInfo: any, totalSize: any, progress: any) {
      const progressNum = parseInt(String(progress * 100));
      if (percent.value > 0 && progressNum) loadingMsg.value && setTimeout(loadingMsg.value, 0);
      percent.value = progressNum;
    },
    // 上传凭证超时
    onUploadTokenExpired: function (uploadInfo: any) {
      http
        .refreshUploadVideo({ params: { video_id: uploadInfo.videoId } })
        .then((res) => {
          let uploadAuth = res.data.data.UploadAuth;
          uploader.resumeUploadWithAuth(uploadAuth);
        })
        .catch(() => {
          uploading.value = false;
        });
      loadingMsg.value && setTimeout(loadingMsg.value, 0);
      message.info('上传凭证超时');
    },
  });
  return uploader;
};
// 腾讯上传
const tcVodVideoId = ref();
const tcVodUpload = () => {
  let data = {
    title: videoList.value.name,
    type: 1,
    size: videoList.value.size,
  };
  return http
    .getApplyVideoUpload(data)
    .then((res) => {
      //       //获取签名
      if (res.data.code == 200) {
        tcVodVideoId.value = res.data.data.id;
        let tcVod = new TcVod({
          //腾讯云-添加签名
          getSignature: () => res.data.data.signature,
        });
        const vUploader = tcVod.upload({
          //腾讯云-初始化上传功能
          mediaFile: videoList.value.originFileObj,
        });
        vUploader.on('media_upload', function (info:any) {
          loadingMsg.value = message.loading('上传准备中，请耐心等候...', 0);
        });
        //   // 视频上传进度
        vUploader.on('media_progress', (info:any) => {
          const progressNum = parseInt(String(info.percent * 100));
          if (percent.value > 0 && progressNum) loadingMsg.value && setTimeout(loadingMsg.value, 0);
          percent.value = progressNum;
        });
        vUploader
          .done()
          .then((res: any) => {
            let data = {
              video_id: tcVodVideoId.value,
              file_id: res.fileId,
              cover: res.video.url,
            };
            http.getVideoInfos(data).then((res) => {
              setTimeout(() => {
                demandVideoList();
              }, 2000);
              uploading.value = false;
              loadingMsg.value && setTimeout(loadingMsg.value, 0);
            });
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        existence.value = true;
        existenceText.value = res.data.error;
        uploading.value = false;
        loadingMsg.value && setTimeout(loadingMsg.value, 0);
      }
    })
    .catch((res) => {
      existence.value = true;
      existenceText.value = res.data.error;
      uploading.value = false;
      loadingMsg.value && setTimeout(loadingMsg.value, 0);
    });
};

onUnmounted(() => {
  loadingMsg.value && setTimeout(loadingMsg.value, 0);
  clearInterval(interval);
  clearInterval(aliyunInterval);
});

const usedGuide = ref(false);
const usedGuideId = ref('');
const usedGuideDis = ref(false);
const submit_preprocess_jobs = () => {
  http
    .submit_preprocess_jobs({ VideoId: usedGuideId.value })
    .then((res) => console.log())
    .catch((err) => console.error(err.data.error));
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(aRangePicker), {
              ranges: ranges,
              "show-time": { format: 'HH:mm' },
              format: "YYYY-MM-DD HH:mm",
              onChange: _unref(demandVideoList),
              value: queryForm.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm).value = $event)),
              class: "mod_range_picker container_textLeft_picker"
            }, {
              suffixIcon: _withCtx(() => [
                _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
              ]),
              _: 1
            }, 8, ["onChange", "value"]),
            _createVNode(_unref(aInputSearch), {
              class: "mod_range_picker_search",
              value: _unref(obj).search,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(obj).search) = $event)),
              placeholder: "请输入关键字",
              onSearch: _unref(demandVideoList)
            }, {
              enterButton: _withCtx(() => [
                _createVNode(_unref(SearchOutlined))
              ]),
              _: 1
            }, 8, ["value", "onSearch"]),
            _createVNode(_unref(aUpload), {
              name: "file",
              action: "/api/v1/common/check_resources_used",
              headers: { token: _unref(token) },
              class: "avatar_uploader_imgs",
              accept: ".mp4, .avi, .mov, .rmvb, .rm, .flv, .f4v, .wmv, .mkv, .m3u8, .asf",
              onChange: uploadVideo,
              "show-upload-list": false,
              "transform-file": transformFile,
              disabled: uploading.value
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(aButton), { class: "mod_btn mod_btn_primary container_textLeft_btn" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_unref(UploadOutlined), null, null, 512), [
                      [_vShow, !uploading.value]
                    ]),
                    _withDirectives(_createVNode(_unref(aSpin), { indicator: _unref(indicators) }, null, 8, ["indicator"]), [
                      [_vShow, uploading.value]
                    ]),
                    _createTextVNode(" 上传视频 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["headers", "disabled"]),
            (_unref(videoJianji))
              ? (_openBlock(), _createBlock(_unref(aButton), {
                  key: 0,
                  type: "primary",
                  class: "merge",
                  disabled: !_unref(isSelected) && checkNum.value > 1 ? false : true,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (jumpMerge()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("合并")
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_a_checkbox, {
              class: "select",
              checked: checked.value,
              "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((checked).value = $event)),
              onChange: _cache[4] || (_cache[4] = ($event: any) => (SelectAll()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("选择")
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_component_a_checkbox, {
              class: "select",
              checked: selected.value,
              "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((selected).value = $event)),
              onChange: _cache[6] || (_cache[6] = ($event: any) => (CheckAll()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("全选")
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_unref(aButton), {
              type: "link",
              danger: "",
              disabled: _unref(isSelected),
              onClick: deleteLive
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_svg_icon, {
                  class: "mod_btn_icon",
                  "icon-class": "del"
                })
              ]),
              default: _withCtx(() => [
                _createTextVNode(" 删除 ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(aAlert), {
            type: "warning",
            class: "warn_content",
            message: "许多因素会影响转码速度，例如输入文件的时长，分辨率以及比特率，转码模板设置等。一般作业时长为输入文件时长的0.5倍到1.5倍之间。如果收到大量作业，它们将排序处理。",
            banner: "",
            closable: ""
          })
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(aProgress), {
            percent: percent.value,
            status: "active",
            format: (percent) => `上传中：${percent}%`
          }, null, 8, ["percent", "format"])
        ], 512), [
          [_vShow, uploading.value]
        ]),
        (showLoading.value)
          ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
          : (live.value.length === 0)
            ? (_openBlock(), _createBlock(_component_a_empty, {
                key: 1,
                class: "empty_wrap",
                image: _unref(emptyDataSec),
                description: "页面暂无数据"
              }, null, 8, ["image"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(live.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "container_footer_left",
                    key: index,
                    onClick: ($event: any) => (_unref(getLive)(item.id))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["footer_to", [checked.value || selected.value ? GetChecktclassName.value : '', keys.value[item.id] ? 'item_select_actived' : '']])
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _withDirectives(_createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_svg_icon, {
                              class: "dot_block_icon",
                              "icon-class": "media_dot_sign"
                            })
                          ], 512), [
                            [_vShow, item.dotting_status]
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("img", {
                              src: item.cover_url,
                              alt: ""
                            }, null, 8, _hoisted_15),
                            _createElementVNode("div", _hoisted_16, _toDisplayString(item.code == 200 ? item.duration : '正在转码...'), 1),
                            _createElementVNode("div", {
                              class: "footer_play",
                              onClick: ($event: any) => (videoPlay(item))
                            }, [
                              _createVNode(_component_svg_icon, {
                                class: "footer_play_svg",
                                "icon-class": "play"
                              })
                            ], 8, _hoisted_17)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("p", null, "创建时间：" + _toDisplayString(item.created_at), 1),
                            _createElementVNode("p", null, [
                              _createTextVNode("分"),
                              _hoisted_20,
                              _createTextVNode("率：" + _toDisplayString(item.resolution), 1)
                            ]),
                            _createElementVNode("p", null, "文件大小：" + _toDisplayString(item.size), 1)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_unref(aButton), {
                              class: "edit_btn",
                              type: "link",
                              onClick: ($event: any) => (!selected.value && !checked.value ? edits(item) : '')
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_svg_icon, {
                                  class: "mod_btn_icon",
                                  "icon-class": "media_edit"
                                })
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" 编辑 ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            (_unref(videoJianji))
                              ? (_openBlock(), _createBlock(_unref(aButton), {
                                  key: 0,
                                  class: "edit_btn",
                                  type: "link",
                                  onClick: ($event: any) => (!selected.value && !checked.value ? buildTimeLine(item) : '')
                                }, {
                                  icon: _withCtx(() => [
                                    _createVNode(_component_svg_icon, {
                                      class: "mod_btn_icon",
                                      "icon-class": "media_clip"
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createTextVNode(" 剪辑 ")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true),
                            _createVNode(_unref(aButton), {
                              onClick: ($event: any) => (!selected.value && !checked.value ? showModal(item) : ''),
                              class: "edit_btn",
                              type: "link"
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_svg_icon, {
                                  class: "mod_btn_icon",
                                  "icon-class": "media_download"
                                })
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" 下载 ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            (_unref(videoDoting))
                              ? (_openBlock(), _createBlock(_unref(aButton), {
                                  key: 1,
                                  class: "edit_btn",
                                  type: "link",
                                  onClick: ($event: any) => (!selected.value && !checked.value ? clickEditorDot(item) : '')
                                }, {
                                  icon: _withCtx(() => [
                                    _createVNode(_component_svg_icon, {
                                      class: "mod_btn_icon",
                                      "icon-class": "media_dol"
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createTextVNode(" 打点 ")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item_select_arrow", [checked.value || selected.value ? GetSelectClassName.value : '', keys.value[item.id] ? 'item_select_actived' : '']])
                        }, [
                          _createVNode(_component_svg_icon, {
                            class: "item_select_arrow_icon",
                            "icon-class": "checked"
                          })
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, _toDisplayString(item.title), 1)
                      ])
                    ], 2)
                  ], 8, _hoisted_10))
                }), 128))
              ])),
        (live.value.length != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createVNode(_unref(aPagination), {
                "show-quick-jumper": "",
                total: pageConfig.totalSize,
                current: pageConfig.current,
                "onUpdate:current": _cache[7] || (_cache[7] = ($event: any) => ((pageConfig.current) = $event)),
                "page-size": pageConfig.pageSize,
                "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((pageConfig.pageSize) = $event)),
                pageSizeOptions: pageConfig.options,
                "show-less-items": "",
                "show-size-changer": "",
                onChange: _unref(demandVideoList),
                onShowSizeChange: _unref(demandVideoList)
              }, null, 8, ["total", "current", "page-size", "pageSizeOptions", "onChange", "onShowSizeChange"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_unref(aModal), {
      visible: confirm.value,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((confirm).value = $event)),
      title: "编辑信息",
      centered: "",
      onOk: keep,
      okText: "保存"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createVNode(CUpload, {
                "handle-change": handlePreview,
                loading: loading.value,
                "image-name": _unref(obj).cover_url,
                "click-stop": imageDel,
                class: "ant_upload"
              }, null, 8, ["loading", "image-name"])
            ])
          ]),
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_a_input, {
                value: _unref(obj).realm,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_unref(obj).realm) = $event)),
                placeholder: "请输入标题"
              }, null, 8, ["value"])
            ])
          ]),
          _hoisted_33,
          _withDirectives(_createElementVNode("div", _hoisted_34, [
            _createVNode(_component_a_checkbox, {
              checked: usedGuide.value,
              "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((usedGuide).value = $event)),
              disabled: usedGuideDis.value
            }, null, 8, ["checked", "disabled"]),
            _createTextVNode("   用于直播导播 ")
          ], 512), [
            [_vShow, _unref(showUseGuide)]
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(aModal), {
      visible: downs.value,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((downs).value = $event)),
      title: "视频下载",
      centered: "",
      onOk: _cache[14] || (_cache[14] = ($event: any) => (downs.value = false)),
      okText: "保存",
      class: "avatar_uploader_modal",
      footer: null
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(obj).domain), 1),
            _createElementVNode("div", {
              class: "down_clone copyer",
              "data-clipboard-target": "#copy",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (Copylist('.copyer')))
            }, [
              _createVNode(_unref(aButton), { class: "clone_edition" }, {
                default: _withCtx(() => [
                  _createTextVNode("复制")
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_unref(aButton), {
                class: "edition",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_42
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_unref(aButton), {
                class: "edition",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_44
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(CDelModal, {
      visible: deletes.value,
      centered: "",
      ok: ConfirmDelete,
      close: openDelModal
    }, {
      title: _withCtx(() => [
        _createTextVNode("此操作将删除该文件，是否继续？")
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(aModal), {
      visible: modal2Visible.value,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((modal2Visible).value = $event)),
      centered: "",
      footer: null,
      zIndex: 2000,
      width: "65%",
      onCancel: modal2cancel,
      closable: false
    }, {
      default: _withCtx(() => [
        (playStatus.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("video", {
                ref_key: "videoRef",
                ref: videoRef,
                id: "videojs-player",
                controls: "",
                class: "video-js vjs-matrix vjs-default-skin vjs-big-play-centered"
              }, null, 512),
              _createElementVNode("div", {
                style: {"position":"absolute","top":"-20px","right":"-14px","cursor":"pointer"},
                onClick: modal2cancel
              }, "✖")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(CDelModal, {
      visible: existence.value,
      centered: "",
      ok: 
        () => {
          existence.value = false;
        }
      ,
      close: 
        () => {
          existence.value = false;
        }
      
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(existenceText.value), 1)
      ]),
      _: 1
    }, 8, ["visible", "ok", "close"])
  ]))
}
}

})